import { apiClient } from './apiClient';

/*
    GET obtiene las definiciones de las columnas de la tabla
 */
export const fetchColumnDefinitions = async () => {
    try {
        const response = await apiClient.get('/claims/describe');
        return response.data;
    } catch (error) {
        throw error;
    }
};

/*
    GET obtiene los datos de la tabla y las filtra para mostrar solo las ready to claim TODO: cambiar endpoint para que envíe solo los datos necesarios (y no todo)
 */
export const fetchFilteredData = async () => {
    try {
        const response = await apiClient.get('/claims/listar');
        return response.data.filter(item => item.status === "Ready to Claim");
    } catch (error) {
        throw error;
    }
};

export const fetchClaimsDetailData = async (option, id) => {
    try {
        const response = await apiClient.get(`/claims/listar?option=${option}&id=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

/*
    POST aprueba un reclamo por ID
 */
export const aprobarReclamo = async (id, aprobado = true) => {
    try {
        const response = await apiClient.post('/claims/aprobarreclamo', { id, aprobado });
        return response.data;
    } catch (error) {
        throw error;
    }
}
